// A random id per browser, sent on every API request as X-POP-Device-Id. The backend only
// stores a hash of it and uses it for the new-device login check (trusted devices).
const STORAGE_KEY = 'pop.deviceId'

export const DEVICE_ID_HEADER = 'X-POP-Device-Id'

function generate () {
  const cryptoObj = window.crypto || window.msCrypto
  if (cryptoObj && cryptoObj.randomUUID) return cryptoObj.randomUUID()
  const bytes = new Uint8Array(16)
  if (cryptoObj && cryptoObj.getRandomValues) {
    cryptoObj.getRandomValues(bytes)
  } else {
    for (let i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256)
  }
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
}

export function getDeviceId () {
  try {
    let id = localStorage.getItem(STORAGE_KEY)
    if (!id) {
      id = generate()
      localStorage.setItem(STORAGE_KEY, id)
    }
    return id
  } catch (e) {
    return ''
  }
}
